import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { FaChevronCircleRight } from "react-icons/fa";
import { Row, Col } from "@/components/Grid";
import { Input, SelectSearch } from "@/components/Form";
import Paginator, { Loading } from "@/components/Paginator";
import EventEmitter from "@/event-emitter";
import { moeda } from "@/formatters";

import { VerDetalhes, TotalResult, BuscarVagas } from "./styles";

import { VagaCard } from "./styles";

function ListarVagas({ history }) {
  const [vagas, setVagas] = useState([]);
  const [loadingVagas, setLoadingVagas] = useState(false);
  const [totalVagas, setTotalVagas] = useState(null);
  const [query, setQuery] = useState({ count: 9 });

  const paginatorRef = useRef();

  function handlePaginatorResetAndFetchData(event) {
    if (paginatorRef.current) {
      paginatorRef.current.resetAndFetchData();
    }
  }

  function handleOnFetchComplete(data) {
    setVagas(data.data);
    setTotalVagas(data.paginator.total);
  }

  function handleOnLoading(loading) {
    setLoadingVagas(loading);
  }

  function handleOpenVaga(vagaId) {
    history.push(`/vaga/${vagaId}`);
  }

  function handleCidadeChange(cidades) {
    if (!cidades.length) return;
    const cidade_id = cidades[0].id;
    setQuery(state => {
      return { ...state, cidade_id };
    });
  }

  function mapOptionsCidades(data) {
    return data.map(d => {
      return { id: d.id, title: d.nome };
    });
  }

  function handleOnChange(event) {
    const { name, value } = event.target;
    setQuery(state => {
      return { ...state, [name]: value };
    });
  }

  function renderVagas() {
    return (
      <>
        {totalVagas != null && <TotalResult>{totalVagas} vagas</TotalResult>}
        <Loading loading={loadingVagas}>
          <Row hascols>
            {vagas.map(vaga => {
              const { cursos } = vaga;

              const cursosList = cursos.length ? (
                <ul className="cursos">
                  {cursos.map(curso => {
                    return (
                      <li>
                        {curso.nome} ({curso.nivel.nome})
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <></>
              );

              return (
                <Col xl="1/3" lg="1/2" md="1" sm="1" key={vaga.id}>
                  <VagaCard onClick={() => handleOpenVaga(vaga.id)}>
                    <div className="body">
                      <h4 className="tipo">{vaga.empresa.nome_exibicao}</h4>
                      <h5 className="area">{vaga.empresa.atuacao}</h5>
                      <h3 className="titulo">
                        Vaga Nº {vaga.id} - {vaga.titulo}
                      </h3>
                      <h5 className="remuneracao">
                        {moeda(Number(vaga.remuneracao))}
                        {Number(vaga.pcd) === 1 && (
                          <span> (Exclusivo para PCD)</span>
                        )}
                      </h5>
                      <h5 className="local">
                        {vaga.cidade.nome}/{vaga.cidade.estado.sigla}
                      </h5>
                      {cursosList}
                    </div>
                    <div className="footer">
                      <VerDetalhes>
                        <FaChevronCircleRight /> Ver detalhes
                      </VerDetalhes>
                    </div>
                  </VagaCard>
                </Col>
              );
            })}
          </Row>
        </Loading>
      </>
    );
  }

  function renderFiltros() {
    return (
      <BuscarVagas>
        <Row hascols>
          <Col sm="1" md="1/2" lg="1/5">
            <Input
              type="number"
              name="vaga_id"
              label="Número da vaga"
              placeholder="número da vaga"
              onChange={handleOnChange}
            />
          </Col>
          <Col sm="1" md="1/2" lg="2/5">
            <Input
              name="vaga_titulo_empresa"
              label="Buscar vagas"
              placeholder="Digite o nome da vaga ou empresa"
              onChange={handleOnChange}
            />
          </Col>
          <Col sm="1" md="1" lg="2/5">
            <SelectSearch
              name="cidade_id"
              label="Cidade"
              endpoint="cidades"
              searchParam="nome"
              mapOptions={mapOptionsCidades}
              onChange={handleCidadeChange}
              firstOption={{ id: null, title: "Todos" }}
            />
          </Col>
        </Row>
      </BuscarVagas>
    );
  }

  useEffect(() => {
    EventEmitter.subscribe("vaga-added", event =>
      handlePaginatorResetAndFetchData(event)
    );
  }, []);

  return (
    <>
      {renderFiltros()}
      {renderVagas()}
      <Paginator
        endpoint="vagas"
        onFetchComplete={handleOnFetchComplete}
        onLoading={handleOnLoading}
        query={query}
        ref={paginatorRef}
      />
    </>
  );
}

export default withRouter(ListarVagas);
